module.exports = {
    toCurrency: (num) => {
        let am = Number(num).toFixed();
        const formatter = new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'PHP',
            minimumFractionDigits: 2
          })
        return formatter.format(am);    

    },
    numbering: (nm) => {
        const int = parseInt(nm),
          digits = [int % 10, int % 100],
          ordinals = ['st', 'nd', 'rd', 'th'],
          oPattern = [1, 2, 3, 4],
          tPattern = [11, 12, 13, 14, 15, 16, 17, 18, 19];
        return oPattern.includes(digits[0]) && !tPattern.includes(digits[1])
          ? int + ordinals[digits[0] - 1]
          : int + ordinals[3];
}
}